import Vue from 'vue'
import lodash from 'lodash'
import $ from 'jquery'
import jqueryUi from 'jquery-ui'
import Cookies from 'js-cookie'
import ko from 'vee-validate/dist/locale/ko';
import VeeValidate, { Validator } from 'vee-validate';
import moment from 'moment';

// Number.parseInt polyfill
window.Number.parseInt = parseInt;

// Number.isInteger polyfill
Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
        isFinite(value) &&
        Math.floor(value) === value;
};

$.ajaxSetup({
    data: {is_ajax: true}
});


// window.$ = $;
window.Vue = Vue;
window.Cookies = Cookies;
window.redirectWithCookie = function (url, cookies) {
    let expire_date = new Date();
    expire_date.setTime(expire_date.getTime() + (5 * 1000));

    if (cookies.expires !== undefined)
        expire_date = cookies.expires;

    _.each(cookies, function (cookie) {
        Cookies.set(cookie.key, cookie.value, { expires: expire_date });
    });

    location.href = url;
}

import Device from './Device'
import DeviceList from './DeviceList'
import User from './User'
import Signup from './Signup'
import DaumPostcode from './DaumPostcode'
import Alert from './Alert'
import Pagination from './Pagination'
import ProjectList from './ProjectList'
import ProjectApplication from './ProjectApplication'
import Project from './Project'
import Attachments from './Attachments'

Vue.use(VeeValidate);
Validator.localize('ko', ko);

Validator.extend('unique_id', {
    getMessage: field => '이미 사용중인 아이디입니다.',
    validate: value => new Promise((resolve => {
        $.ajax({
            method: "GET",
            url: "/auth/duplicated_id/" + value
        }).done((is_duplicated_id) => {
            resolve({
                valid: ! is_duplicated_id
            })
        })
    }))
});

Validator.extend('afterDate', {
    getMessage(field, args) {
        return args + " 보다 이후날 이어야 합니다."
    },
    validate(value, args) {
        return moment(value).isAfter(args[0])
    }
})

Validator.extend('beforeDate', {
    getMessage(field, args) {
        return args + " 보다 이전일 이어야 합니다."
    },
    validate(value, args) {
        return moment(value).isBefore(args[0])
    }
})

Vue.component('user', User);
Vue.component('alert', Alert);
Vue.component('signup', Signup);
Vue.component('device', Device);
Vue.component('device-list', DeviceList);
Vue.component('project-list', ProjectList);
Vue.component('pagination', Pagination);
Vue.component('project-application', ProjectApplication);
Vue.component('project', Project);
Vue.component('attachments', Attachments);

Vue.filter('moment_format_LL', function (value) {
    return moment(value).format('LL');
})
Vue.filter('moment_format_LT', function (value) {
    return moment(value).format('LT');
})
Vue.filter('moment_format_LLL', function (value) {
    return moment(value).format('LLL');
})

moment.locale('ko');

if (document.getElementById('app-component')) {

    window.app_component = new Vue({
        'el': '#app-component',
        data: {},
        methods: {
            onClickProject(project_id) {
                window.location.href = '/project/' + project_id;
            }
        }
    })
}

if (document.getElementById('app-component2')) {

    new Vue({
        'el': '#app-component2',
        data: {
            project_id: ""
        },
        methods: {
            onClickProject(project_id) {
                this.project_id = project_id;
            }
        }
    })

}






// WEBPACK FOOTER //
// ./src/main.js